import { render, staticRenderFns } from "./inquiryOperate.vue?vue&type=template&id=3e0b3fe2&scoped=true"
import script from "./inquiryOperate.vue?vue&type=script&lang=js"
export * from "./inquiryOperate.vue?vue&type=script&lang=js"
import style0 from "./inquiryOperate.vue?vue&type=style&index=0&id=3e0b3fe2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0b3fe2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e0b3fe2')) {
      api.createRecord('3e0b3fe2', component.options)
    } else {
      api.reload('3e0b3fe2', component.options)
    }
    module.hot.accept("./inquiryOperate.vue?vue&type=template&id=3e0b3fe2&scoped=true", function () {
      api.rerender('3e0b3fe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/indexes/inquiry/components/inquiryOperate.vue"
export default component.exports